module.exports = __webpack_public_path__ + "img/12.03d3c482.png";